import React from 'react';
import ColorPickerItem from '@framework/workbench/drawer/components/color-picker/color-picker-item';
import { ColorOptions } from '@framework/workbench/drawer/common/config';
import { TdwDrawerConstMap } from '@framework/workbench/drawer/report';
import { rgbaToHexA } from '@framework/frame-pc/components/color-picker/utils';
import { alphaToOpacity } from '@framework/workbench/drawer/utils';
import { convertColor } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/utils/color';
import { getColorRGB, rgb2Hex } from '@src/slide/infrastructure/module/independent/color/transform';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export const getDrawerColorOptions = (callback, menuManager: IMenuManager | undefined) => ({
    ...ColorOptions,
    customContent: <ColorPickerItem
        onColorChange={(color: ITDColor) => {
            callback(
                convertColor(color.srgb_color).hex,
                TdwDrawerConstMap.color.picker,
            );
        }}
        menuManager={menuManager}
    />,
});

const HEX_COLOR_LENGTH = 7; //    颜色格式为#000000，长度为7
export const getColorParams = (value: string) => {
    const hexColor = rgb2Hex(value).slice(0, HEX_COLOR_LENGTH);
    const rgbaColor = rgbaToHexA(value);
    return typeof rgbaColor?.o !== 'undefined' ? { color: hexColor, opacity: alphaToOpacity(rgbaColor.o) } : { color: hexColor };
};

export const getRgbaColor = (color: string): string => {
    if (color.startsWith('rgba(')) {
        return color;
    }
    const rgb = getColorRGB(color);
    if (rgb?.length === 4) {
        // 为啥不写a
        return `rgb(${rgb[0]},${rgb[1]},${rgb[2]},${parseFloat(rgb[3].toFixed(2))})`;
    }
    return color;
};

export const getRgbaColorWithAlpha = (color: string): string => {
    if (!color) return '';
    if (color.startsWith('rgba(')) {
        return color;
    }
    const rgb = getColorRGB(color);
    if (rgb?.length === 4) {
        const alpha = `${parseFloat(rgb[3].toFixed(2))}`;
        const rgba = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
        if (alpha === '1') {
            return rgbaToHexA(rgba).hex;
        }
        return rgba;
    }
    return color;
};
